var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataVaultEdit = function SvgDataVaultEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.865,
    height: 68.865,
    viewBox: "0 0 68.865 68.865"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "data-vault-edit_svg__a",
    width: 68.865,
    height: 68.865,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "data-vault-edit_svg__b",
    width: 48.519,
    height: 48.519,
    x: 10.173,
    y: 10.172,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Data Vault"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#data-vault-edit_svg__a)",
    transform: "translate(-.005 .004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#467181",
    "data-name": "Ellipse 276",
    opacity: 0.5,
    transform: "rotate(-1 398.112 -512.214)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#data-vault-edit_svg__b)",
    transform: "translate(-.005 .004)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#467181",
    stroke: "#fff",
    "data-name": "Ellipse 251",
    transform: "rotate(-1 1023.059 -1147.932)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.933 23.432h-15a1.5 1.5 0 0 0-1.5 1.5v10a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-10a1.5 1.5 0 0 0-1.5-1.5m-.5 11h-14v-9h14Z",
    "data-name": "Secondary Layer",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.683 37.932h-2.25l-.5-1.5h-3l-.5 1.5h-2.25a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h8.5a.75.75 0 0 0 0-1.5m-11.25-12.5v9h14v-9Z",
    "data-name": "Primary Layer"
  })))));
};
export { SvgDataVaultEdit as ReactComponent };
export default "data:image/svg+xml;base64,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";